<template>
  <content-dialog
    :visible.sync="modalVisible"
    scrollable
    max-width="500"
  >
    <!--<editor-fold desc="Dialog title">-->
    <template slot="dialogTitle">
      Revert yacht sales status
    </template>
    <!--</editor-fold>-->

    <v-card-text
      class="pa-6"
    >
      <v-autocomplete
        v-model="status"
        outlined
        label="Select status"
        :items="statuses"
        item-text="label"
        item-value="key"
      />

      <p v-if="status">
        Are you sure you want to revert sales status to {{ status }}?
      </p>
    </v-card-text>

    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="!status"
        :loading="submitting"
        @click="updateYacht"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Yes, revert status
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
  import Yacht from '@/models/Yacht'
  import ContentDialog from '@/components/helpers/Dialog'

  export default {
    name: 'RevertInvestmentStatusDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: Boolean,
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        status: null,
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      yachtDirty: {
        get: function () {
          return this.yacht
        },
        set: function (value) {
          this.$emit('update:yacht', value)
        }
      },
      statuses: function () {
        let statuses = []

        for (let status in Yacht.investmentStatusData) {
          if (status === this.yachtDirty.investment_status) break

          statuses.push(Yacht.investmentStatusData[status])
        }

        return statuses
      }
    },
    methods: {
      async updateYacht() {
        this.submitting = true

        const data = { investment_status: this.status }

        try {
          this.yachtDirty = await Yacht.api.revertInvestmentStatus(data, this.yachtDirty.id)
          this.modalVisible = false
          this.$store.dispatch('alert', {
            'text': 'Yacht sales status marked as ' + this.status,
            'color': 'success'
          })
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
